/**
 * Display various areas of the game
 * @class Camera
 * @param  {Number} x     
 * @param  {Number} y     
 * @param  {Number} width 
 * @param  {Number} height
 */
export default class Camera {
    constructor(x=0, y=0, width=0, height=0) {
        this._x = x;
        this._y = y;
        this._width = width;
        this._height = height;
    }

    /**
     * @method translate
     * @param  {Float} x The new position
     * @param  {Float} y The new position
     */
    translate(x=0, y=0) {
        this._x += x;
        this._y += y;
    }

    get x() { return this._x; }

    get y() { return this._y; }

    get width() { return this._width; }

    get height() { return this._height; }

    set x(val) { this._x = val; }

    set y(val) { this._y = val; }

    set width(val) { this._width = val; }

    set height(val) { this._height = val; }
}


/** WEBPACK FOOTER **
 ** ./src/Camera.js
 **/